import DetailsTabs from '@enerex/unified-ui-react/DetailsTabs';
import { useLayoutEffect, useRef } from 'react';
import { lookupTables } from './lookupTables';

const tabs = lookupTables.map(({ id, title }) => ({
    id,
    // A React node keeps Unified UI labels visible at small screen sizes.
    title: <span>{title}</span>,
    url: `/settings/lookup/${id}`,
}));

const Lookup = () => {
    const panel = useRef(null);
    // DetailsTabs does not expose a disabled option. Keep its layout while
    // disabling unfinished links for pointer, keyboard, and assistive technology.
    useLayoutEffect(() => {
        lookupTables.filter(table => table.disabled).forEach(table => {
            const link = panel.current?.querySelector(`a[href="/settings/lookup/${table.id}"]`);
            if (link) {
                link.setAttribute('aria-disabled', 'true');
                link.setAttribute('tabindex', '-1');
                link.removeAttribute('href');
                link.setAttribute('title', 'Available in a future update');
            }
        });
    }, []);
    const preventDisabledNavigation = event => {
        if (event.target.closest('[aria-disabled="true"]')) {
            event.preventDefault();
            event.stopPropagation();
        }
    };
    return (
    <section className="settings-lookup" aria-labelledby="lookup-title">
        <h4 id="lookup-title">Lookup</h4>
        <div className="settings-lookup__panel" ref={panel} onClickCapture={preventDisabledNavigation}>
            <DetailsTabs tabs={tabs} />
        </div>
    </section>
    );
};

export default Lookup;
